import { createContext, useContext } from 'react';

import { CommonApplicationServices } from './CommonApplicationServices';

export const CommonApplicationServicesContext = createContext<CommonApplicationServices | null>(
  null,
);

export const useCommonAppServices = () => {
  const context = useContext(CommonApplicationServicesContext);
  if (!context) {
    throw new Error(
      'useCommonAppServices() must be used within <CommonApplicationServicesContext.Provider>',
    );
  }
  return context;
};
